var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import BaseDrawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/system';
import { useTheme } from '@mui/material';
import { DrawerHeader, DrawerTabs } from './components';
export const Drawer = (_a) => {
    var { open, title, subTitle, anchor, onClose, content, belowTabContent, tabs, tabsProps, drawerSize = 'sm', selectedTab, onChangeTab } = _a, rest = __rest(_a, ["open", "title", "subTitle", "anchor", "onClose", "content", "belowTabContent", "tabs", "tabsProps", "drawerSize", "selectedTab", "onChangeTab"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const defaultAnchor = isMobile ? 'bottom' : 'right';
    const width = drawerSize === 'sm' ? '380px' : drawerSize === 'lg' ? '680px' : '500px';
    return (React.createElement(BaseDrawer, Object.assign({}, rest, { anchor: defaultAnchor || anchor, container: () => {
            const id = 'hpernova-class-wrapper';
            const hpernovaClassWrapper = document.getElementById(id);
            if (hpernovaClassWrapper) {
                return hpernovaClassWrapper;
            }
            const elemDiv = document.createElement('div');
            elemDiv.classList.add('_hy');
            elemDiv.id = id;
            document.body.appendChild(elemDiv);
            return elemDiv;
        }, PaperProps: {
            dataqa: 'drawer-paper',
            sx: {
                width: {
                    md: width,
                },
                maxHeight: {
                    xs: 'calc(100vh - 64px)',
                    md: '100vh',
                },
                height: '100vh',
                borderTopRightRadius: {
                    xs: '16px',
                    md: 0,
                },
                borderTopLeftRadius: {
                    xs: '16px',
                    md: 0,
                },
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none', // For Chrome, Safari, and Opera
                },
                msOverflowStyle: 'none',
            },
        }, onClose: onClose, open: open }),
        React.createElement(Stack, { sx: {
                position: 'relative',
                height: '100%',
            } },
            React.createElement(Box, { component: "div", sx: {
                    height: {
                        xs: '45px',
                        md: '62px',
                    },
                } },
                React.createElement(DrawerHeader, { title: title, subTitle: subTitle, onClose: onClose, width: !isMobile ? width : undefined })),
            React.createElement(Box, null,
                content && (React.createElement(Box, { sx: {
                        marginTop: tabs
                            ? {
                                xs: '20px',
                                md: '62px',
                            }
                            : undefined,
                    } }, content)),
                React.createElement(Box, null, tabs && (React.createElement(DrawerTabs, Object.assign({ tabs: tabs, selectedTab: selectedTab, onChangeTab: onChangeTab, isSticky: content ? false : true, sx: {
                        marginTop: typeof content === 'undefined'
                            ? {
                                xs: '55px',
                                md: '62px',
                            }
                            : '0px',
                    } }, tabsProps)))),
                belowTabContent))));
};
